<script setup lang="ts">
import AutoComplete from "../components/AutoComplete.vue";
import TheWelcome from "../components/TheWelcome.vue";

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";

let keywordInput = ref();
let keyword = ref("");

const router = useRouter();
const $toast = useToast();
function searchWithKeyword() {
  if (keyword.value.length < 3) {
    $toast.open({
      type: "error",
      position: "top",
      message: `Search keywords should be more than 3 characters!`,
    });
  } else {
    router.push({
      path: "/keyword-search/" + keyword.value,
      // force: true,
    });
  }
}

function onSelect(id: any) {
  keyword.value = id;
  searchWithKeyword();
}

function updateInput(input: string) {
  keyword.value = input;
}
</script>

<template>
  <main>
    <form class="form-group" v-on:submit.prevent>
      <div class="row">
        <label class="control-label col-auto" for="keyword"
          >Gene name or keyword:
        </label>
        <div class="col-md-8">
          <auto-complete
            ref="keywordInput"
            id="keyword"
            @onSelect="onSelect"
            @updateInput="updateInput"
          ></auto-complete>
        </div>

        <div class="col-auto">
          <button
            class="btn btn-primary"
            type="submit"
            @click="searchWithKeyword"
          >
            Browse
          </button>
        </div>
      </div>
    </form>

    <TheWelcome />
  </main>
</template>

<style scoped>
main {
  padding: 5px 10px;
}

main .control-label {
  margin: 5px 10px;
}

main .form-group {
  margin-bottom: 2rem;
}
</style>
